


import * as Actions from '../actions';

const initialState = {
    isLoading: true,
    errMsg: null,
    data: []
    };


// get active categories
export const allFilesInvoicesReducer = function(state = initialState, action) {
switch (action.type) {
case Actions.ALL_CUSTOMER_FILES_INVOICES:
return { ...state, isLoading: false, errMsg: null, data: action.payload };
case Actions.ALL_CUSTOMER_FILES_INVOICES_LOADING:
return { ...state, isLoading: true, errMsg: null, data: [] };
case Actions.ALL_CUSTOMER_FILES_INVOICES_LOADING_FAILED:
return { ...state, isLoading: false, errMsg: action.payload, data: [] };
default:
return state;
}
};
